import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  OnDestroy
} from '@angular/core';
import { ButtonType } from '@ascschool/interface/setting';
import { CategoryModel } from '@ascschool/model/category/category-model.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { ConfirmComponent } from '@ascschool/project/popups/confirm/confirm.component';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { DegreeService } from '@ascschool/services/category/degree.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { PopupHoatDongVaHoTroNktComponent } from './popup-hoat-dong-va-ho-tro-nkt/popup-hoat-dong-va-ho-tro-nkt.component';
import { CaDisInfrastructuresService } from '@ascschool/services/category/caDisInfrastructures.service';
import { TeachingAndSupportService } from '@ascschool/services/new/teaching-and-support.service';
import { GeneralCategory } from '@ascschool/model/category/general-category.model';
import { Subject } from 'rxjs';
import {takeUntil} from 'rxjs/operators'
@Component({
  selector: 'app-hoat-dong-va-ho-tro-nkt',
  templateUrl: './hoat-dong-va-ho-tro-nkt.component.html',
  styleUrls: ['./hoat-dong-va-ho-tro-nkt.component.scss']
})
export class HoatDongVaHoTroNktComponent implements OnInit,OnDestroy {
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  constructor(
    private msg: NzMessageService,
    private cdRef: ChangeDetectorRef,
    public _authService: AuthService,
    public sizePageService: SizePageService,
    private modalService: NzModalService,
    private authQuery: AuthQuery,
    private service: TeachingAndSupportService,
    public utilService: UtilsService
  ) {}
  get breadcrumbs(): string[] {
    return ['Quản lý đơn vị'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  $unSubcribe = new Subject();
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm: string = '';
  pageIndex: number = 1;
  categoryModel = new CategoryModel();
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[0];
  loading: boolean = true;
  Total: number = 0;
  firstRowOnPage: any;
  listData: any;
  width: number;
  numberControl: number;
  private elementPageHeaderTable: ElementRef;
  @ViewChild('pageSample8', { static: false }) elementPageSample8: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation: number = 50;
  isCollapse = true;
  ngOnInit() {
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[1];
    this.reload();
    this.maxHeight = window.innerHeight;
    this._authService.getNavChangeEmitter().subscribe((item) => {
      this.checkCaculateHeight();
    });
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
  }
  reload() {
    const _this = this;
    this.loading = true;
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[0];
    _this.listData = [];
    this.service.get(this.commonFilter).pipe(takeUntil(this.$unSubcribe)).subscribe(
      (response: any) => {
        const list = response.results ? response.results : [];
        this.Total = response && response.rowCount ? response.rowCount : 0;
        this.firstRowOnPage = response && response.firstRowOnPage ? response.firstRowOnPage : 0;
        _this.listData = list ? list : [];
        _this.loading = false;
      },
      (err: any) => {
        _this.listData = [];
        _this.loading = false;
      }
    );
  }
  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
    this.checkCaculateHeight(this.isCollapse);
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'],
      label: 'Help',
      description: 'Cmd + b',
      command: (e) => this.AddCategoryModel(),
      preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }
  resetForm(): void {}
  //popup
  showPopup(item: any): void {
    this.isResizdePopup = false;
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopupHoatDongVaHoTroNktComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto'
      },
      nzComponentParams: {
        value: item
      },
      nzWidth: 700
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe((results) => {
      if (results) {
        this.reload();
      }
    });
  }
  AddCategoryModel() {
    this.showPopup(null);
  }
  EditCategoryModel(item: any) {
    this.showPopup(item);
  }
  showDeleteCategoryModel(item: GeneralCategory): void {
    const dialogRef = this.modalService.create({
      nzTitle: 'Xóa hoạt động dạy học và hỗ trợ người khuyết tật',
      nzContent: ConfirmComponent,
      nzComponentParams: {
        description: item.name
      },
      nzStyle: { top: '20px' },
      nzMaskClosable: false
    });
    dialogRef.afterClose.subscribe((results) => {
      if (results) {
        this.service.delete(item.id).subscribe((res: any) => {
          this.utilService.notifyResponse(res);
          this.reload();
        });
      }
    });
  }
  handlerResizePopup(){
    this.isResizdePopup = !this.isResizdePopup;
    let width = 700;
    let height = 'auto';
    let top = 30;
    if(this.isResizdePopup === true){
      width = window.innerWidth;
      top = 15;
      height = this.caculateHeightPopup(window.innerHeight) + 50 + 'px';
    }
    this.dialogRef.updateConfig({
      nzWidth: width,
      nzStyle: { 
        top: top + 'px',
      },
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: height,
        height: height,
      }
    });
  }
  ngOnDestroy(): void {
    console.log(this.$unSubcribe);
    
    this.$unSubcribe.next();
    this.$unSubcribe.complete();
}
}
